import IntegrationCallListPagingResultModelBase from '../_generated/modelBases/integration-call-list-paging-result-model-base';

export default class IntegrationCallListPagingResultModel extends IntegrationCallListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
